import { render, staticRenderFns } from "./SynthesisView.vue?vue&type=template&id=1ef7641c&"
import script from "./SynthesisView.vue?vue&type=script&lang=ts&"
export * from "./SynthesisView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports